import { Close } from '@mui/icons-material'
import { Box, Card, Icon, IconButton, Paper, Typography } from '@mui/material'
import { render } from '@testing-library/react'
import React from 'react'
import { formatDateTime } from '../../../utils/dateUtils'
import { DataGrid } from '@mui/x-data-grid'

const StatusLog = ({statusHistory,onClose}) => {
    const columns = [
        { field: 'status', headerName: 'Status', width: 150 },
        { field: 'timestamp', headerName: 'Timestamp', width: 200 ,
            renderCell: (params) => {
                const date = new Date(params.value);
                return formatDateTime(date);
            }
        },
        { field: 'remarks', headerName: 'Remarks', flex:1 ,
                renderCell: (params) => {
                    return (
                        <Box sx={{p:1,fontSize:'0.85rem',color:'text.secondary',width:'100%',whiteSpace:'normal',wordBreak:'break-word'}}>
                            <Typography sx={{fontSize:'0.85rem',color:'text.secondary',width:'100%',whiteSpace:'normal',wordBreak:'break-word'}}>
                        {params.row?.whatsappStatus? params.row?.whatsappStatus?.errors && params.row?.whatsappStatus?.errors[0]?.message || 'N/A':
                        params.row.error?.message || 'N/A'}
                    </Typography>
                        </Box>
                    )
                }
        },
    ]
  return (
    <Paper>
      <Box sx={{display:'flex',alignItems:'center',p:'.5% 1%',borderBottom:'1px solid lightgrey'}}>
        <Typography sx={{fontSize:'0.85rem',fontWeight:'500',color:'text.primary'}}>
            Status History
        </Typography>
        <IconButton onClick={onClose} size='small' sx={{ml:'auto'}} color='error'>
            <Close fontSize='small' />
        </IconButton>
      </Box>
      <Box sx={{p:2}}>
        <DataGrid
            rows={statusHistory}
            getRowId={(row) => row.timestamp} // Assuming timestamp is unique for each status change
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            autoHeight
            // hide pagination
            pagination={false}
            //hide footer
            hideFooter
        />
      </Box>
    </Paper>
  )
}

export default StatusLog
